import {getAuthToken} from '@/utils/token'

export default function RedirectIfAuthenticated (router) {
  router.beforeEach((to, from, next) => {
    let token = getAuthToken()
    let auth = to.meta.requiresAuth
    /**
    * check if pages requiresAuth
    */
    if (auth) {
      /**
      * check if there's a token
      */
      if (token) {
        next()
        return
      }
      next('/login')
      return
    }
    next()
  })
}



// WEBPACK FOOTER //
// ./src/middleware/RedirectIfAuthenticated.js